(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["champion-homepage"] && !Shopify.designMode) return;
  try {
    
  const initializeChampionEvents = (scope = document) => {
    scope.querySelectorAll('[data-ch-event-list]').forEach((eventList) => {
      const cards = [...eventList.querySelectorAll('[data-ch-event-card]')];
      if (!cards.length) return;
      const timeZone = eventList.dataset.chTimeZone || 'America/New_York';
      const dayName = new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone }).format(new Date());
      const weekdays = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
      const currentWeekday = weekdays[dayName];
      if (currentWeekday === undefined) return;
      cards
        .sort((firstCard, secondCard) => {
          const firstOffset = (Number(firstCard.dataset.chEventWeekday) - currentWeekday + 7) % 7;
          const secondOffset = (Number(secondCard.dataset.chEventWeekday) - currentWeekday + 7) % 7;
          return firstOffset - secondOffset;
        })
        .forEach((card, index) => {
          card.hidden = index >= 3;
          eventList.append(card);
        });
    });
  };
  const initializeChampionCarousels = (scope = document) => {
    scope.querySelectorAll('[data-ch-featured-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;
      carousel.dataset.initialized = 'true';
      const slides = [...carousel.querySelectorAll('[data-ch-featured-slide]')];
      const dots = [...carousel.querySelectorAll('[data-ch-slide-dot]')];
      const previousButton = carousel.querySelector('[data-ch-slide-previous]');
      const nextButton = carousel.querySelector('[data-ch-slide-next]');
      const pauseButton = carousel.querySelector('[data-ch-slide-pause]');
      if (slides.length < 2 || !previousButton || !nextButton || !pauseButton) return;
      let activeIndex = 0;
      let playing = carousel.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let timer;
      const speed = Number(carousel.dataset.speed) || 7000;
      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', String(active));
        });
      };
      const startTimer = () => {
        window.clearInterval(timer);
        if (playing) timer = window.setInterval(() => showSlide(activeIndex + 1), speed);
      };
      previousButton.addEventListener('click', () => { showSlide(activeIndex - 1); startTimer(); });
      nextButton.addEventListener('click', () => { showSlide(activeIndex + 1); startTimer(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { showSlide(Number(dot.dataset.chSlideDot)); startTimer(); }));
      pauseButton.addEventListener('click', () => {
        playing = !playing;
        pauseButton.textContent = playing ? 'Ⅱ' : '▶';
        pauseButton.setAttribute('aria-label', playing ? 'Pause slideshow' : 'Play slideshow');
        startTimer();
      });
      startTimer();
    });
  };
  initializeChampionEvents();
  initializeChampionCarousels();
  document.addEventListener('shopify:section:load', (event) => {
    initializeChampionEvents(event.target);
    initializeChampionCarousels(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
